import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { countryPhoneCodes } from "../LandingPage/countryPhoneCode";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const CountryCode25 = ({ selected, setSelected, disable }) => {
  return (
    <Listbox value={selected} onChange={setSelected}>
      {({ open }) => (
        <>
          {/* <Listbox.Label className={'block text-sm text-gray-500 ml-1'}>Country</Listbox.Label> */}
          <div className="relative">
            <Listbox.Button
              className={`relative h-12 w-full ${
                disable ? "bg-[#475a73]" : "bg-[#07274b]"
              } cursor-pointer rounded-lg pr-10 text-left shadow-sm  ${
                !open && ""
              } sm:text-sm`}
            >
              <span className="flex items-center">
                <span
                  className={`ml-3 block truncate font-normal ${
                    !disable ? `text-white` : "text-white/80"
                  }`}
                >{`${selected.dial_code}`}</span>
              </span>
              <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                <ChevronDownIcon
                  className={`h-5 w-5 ${
                    !disable ? `text-white/80` : "text-white/50"
                  }`}
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open && !disable}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-[999999] max-h-56  w-[300px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm md:w-fit">
                {countryPhoneCodes.map((item) => (
                  <Listbox.Option
                    key={item.code}
                    className={({ active }) =>
                      classNames(
                        active ? "bg-indigo-600 text-white" : "text-gray-900",
                        "relative h-11 cursor-default select-none py-2 pl-3 pr-9"
                      )
                    }
                    value={item}
                  >
                    {({ selected, active }) => (
                      <>
                        <div className="flex items-center">
                          <span
                            className={classNames(
                              selected ? "font-semibold" : "font-normal",
                              "ml-3 block truncate"
                            )}
                          >
                            {`${item.name} (${item.dial_code})`}
                          </span>
                        </div>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? "text-white" : "text-indigo-600",
                              "absolute inset-y-0 right-0 flex items-center pr-4"
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
};

export default CountryCode25;
